export const closeBrowserWindow = () => {
  window.open("about:blank", "_self");
  window.close();
};
